import { useTheme } from 'styled-components';

import { Subheadline } from '@/core/components/Typography';

import { MetaSection } from '@/features/Reports/components/MetaSection';

import { ContentText, DetailsContent } from './DetailsSection.styles';
import { LocationMap } from './LocationMap';
import { ReportSectionsBaseProps } from './ReportSections.types';

export const DetailsSection = ({
  report,
  country,
  locationAddress,
  eventDate,
  eventLocalTime,
  categories,
}: ReportSectionsBaseProps) => {
  const { colors } = useTheme();
  const hasLocation = report.location.length > 0;

  return (
    <DetailsContent>
      <MetaSection
        country={country}
        locationAddress={locationAddress}
        eventDate={eventDate ?? ''}
        eventLocalTime={eventLocalTime}
        categories={categories}
        postType={report.reportType}
        impact={report.impact}
        dead={report.victims.dead}
        wounded={report.victims.wounded}
        hostages={report.victims.hostages}
        missing={report.victims.missing}
        arrested={report.victims.arrested}
      />
      {report.content && (
        <ContentText>
          <Subheadline
            type="normal"
            color={colors.secondaryText}
          >
            {report.content}
          </Subheadline>
          {hasLocation && <LocationMap report={report} />}
        </ContentText>
      )}
    </DetailsContent>
  );
};
